const clientStatusLogs = [
  {
    status: 1,
    text: 'Nuestro equipo está verificando que la orden sea válida para su elaboración'
  },
  {
    status: 2,
    text: 'Tu orden se encuentra en cotización'
  },
  {
    status: 3,
    text: 'Verifica que la cotización enviada se adecue a tus necesidades.',
  },
  {
    status: 4,
    text: 'Tu orden de compra se encuentra en elaboración.'
  },
  {
    status: 5,
    text: 'Estamos inspeccionando tu pedido para asegurarnos que sea lo que solicitaste'
  },
  {
    status: 6,
    text: 'Tu pedido se encuentra en camino o listo para recoger. Por favor confírmanos cuando lo tengas en tu posesión.',
  },
  {
    status: 7,
    text: '¡Gracias por confiar en EPNO! Cualquier duda o aclaración, comunícate con nuestro equipo'
  },
  {
    status: 8,
    text: "Tu orden de compra ha sido rechazada por: "
  },
  {
    status: 9,
    text: "Tu orden de compra ha sido cancelada debido a: "
  },
  {
    status: 10,
    text: "Tu orden fue devuelta para edición. Revisa los comentarios, actualiza la información y vuelve a enviarla."
  },
  {
    status: 11,
    text: "Tu solicitud de cancelación ha sido enviada. Motivo: "
  },
  {
    status: 12,
    text: "La orden se encuentra en queja. Da seguimiento en la sección de quejas y comentarios."
  }
]


const adminStatusLogs = [
  {
    status: 1,
    text: 'El vendedor se encuentra verificando que los datos de la orden sean correctos.',
  },
  {
    status: 2,
    text: 'Compras se encuentra cotizando la orden con diferentes proveedores.',
  },
  {
    status: 3,
    text: 'El cliente se encuentra seleccionando la cotización que se adecue más a su necesidad.',
  },
  {
    status: 4,
    text: 'El proveedor se encuentra elaborando la orden',
  },
  {
    status: 5,
    text: 'Ventas está verificando la orden realizada por el proveedor.',
  },
  {
    status: 6,
    text: 'La orden terminada se encuentra en camino o listo para recoger. Espera a que el cliente confirme que el pedido ya ha sido entregado.',
  },
  {
    status: 7,
    text: 'La orden ha concluido.'
  },
  {
    status: 8,
    text: "La orden de compra ha sido rechazada debido a: "
  },
  {
    status: 9,
    text: "La orden de compra fue cancelada debido a: "
  },
  {
    status: 10,
    text: "La orden fue devuelta al cliente para edición. Espera que el cliente actualice y reenvíe la información."
  },
  {
    status: 11,
    text: "El cliente ha solicitado una cancelación. Motivo: "
  },
  {
    status: 12,
    text: "La orden se encuentra en queja. Da seguimiento en la sección de quejas y comentarios."
  }
]

const vendorStatusLogs = [
  {
    status: 1,
    text: "Verifica que el cliente haya subido correctamente los datos de cotización. Si fue así, envía a cotización el servicio." +
      " Si no fue así, devuelve la orden de compra al cliente para que la pueda editar"
  },
  {
    status: 2,
    text: "El comprador se encuentra cotizando la orden de compra con diferentes proveedores. Mantengan contacto para llegar a" +
      " un acuerdo exitoso con el cliente."
  },
  {
    status: 3,
    text: "El cliente se encuentra eligiendo la cotización que se ajuste más a sus necesidades. Favor de mantener contacto con el cliente " +
      "en dado caso de requerir una recotización."
  },
  {
    status: 4,
    text: "La cotización ha sido aceptada. El proveedor se encuentra elaborando la orden."
  },
  {
    status: 5,
    text: "El proveedor ha terminado la orden. Favor de inspeccionar la orden para confirmar que cumpla con los estándares de calidad."
  },
  {
    status: 6,
    text: "La orden se encuentra en proceso de ser entregada. El cliente debe confirmar que el producto sea entregado. " +
      "Para finalizar la entrega, favor de subir la factura sellada y firmada."
  },
  {
    status: 7,
    text: "La orden de compra ha finalizado. En caso de recibir un reclamo, contáctese con el cliente para asistirlo."
  },
  {
    status: 8,
    text: "Rechazaste la orden de compra debido a: "
  },
  {
    status: 9,
    text: "La orden de compra fue cancelada debido a: "
  },
  {
    status: 10,
    text: "Devolviste la orden al cliente para edición. Espera que actualice y reenvíe la información para continuar."
  },
  {
    status: 11,
    text: "El cliente ha solicitado una cancelación. Motivo: "
  },
  {
    status: 12,
    text: "La orden se encuentra en queja. Da seguimiento en la sección de quejas y comentarios."
  }
]

const buyerStatusLogs = [
  {
    status: 1,
    text: "Ventas se encuentra verificando que la información del servicio sea correcta para iniciar cotización."
  },
  {
    status: 2,
    text: "Cotiza con diferentes proveedores la orden de compra. Puedes agregar una orden de compra externa en el botón de " +
      " agregar cotización externa."
  },
  {
    status: 3,
    text: "Espera a que el cliente elija la cotización que se ajuste a su necesidad. Espera la orden de compra del cliente para " +
      "subir la orden de compra para el proveedor. Si el cliente no sube la orden de compra, puedes solicitarla y subirla por él. " +
      "En dado caso de no aceptar ninguna, solicita una recotización."
  },
  {
    status: 4,
    text: "La cotización ha sido aceptada. El proveedor se encuentra elaborando la orden de compra."
  },
  {
    status: 5,
    text: "Ventas se encuentra verificando que la orden cumpla con los estándares de calidad."
  },
  {
    status: 6,
    text: "La orden se encuentra en proceso de ser entregada. El cliente y ventas deben confirmar que la orden ha sido finalizada."
  },
  {
    status: 7,
    text: "La orden de compra ha finalizado. En dado caso de un reclamo, notificar al encargado de la venta."
  },
  {
    status: 8,
    text: "La orden de compra ha sido rechazada debido a: "
  },
  {
    status: 9,
    text: "La orden de compra ha sido cancelada debido a: "
  },
  {
    status: 10,
    text: "La orden fue devuelta al cliente para edición. Espera que actualice la información para continuar con la cotización."
  },
  {
    status: 11,
    text: "El cliente ha solicitado una cancelación. Motivo: "
  },
  {
    status: 12,
    text: "La orden se encuentra en queja. Da seguimiento en la sección de quejas y comentarios."
  }
]

const supplierStatusLogs = [
  {
    status: 2,
    text: 'Envía tu cotización con los datos requeridos.',
  },
  {
    status: 3,
    text: 'El cliente se encuentra seleccionando la cotización.',
  },
  {
    status: 4,
    text: '¡Felicidades, tu cotización ha sido aceptada! Elabora el servicio solicitado. Una vez terminado, actualiza el estado para que EPNO inspeccione el producto.',
  },
  {
    status: 5,
    text: 'EPNO se encuentra inspeccionando el servicio.',
  },
  {
    status: 6,
    text: 'Puedes entregar el servicio a tu cliente.',
  },
  {
    status: 7,
    text: 'El servicio ha concluido. Cualquier duda o aclaración, contacta a EPNO.'
  },
  {
    status: 9,
    text: 'La orden de compra ha sido cancelada debido a: '
  },
  {
    status: 10,
    text: 'La orden fue devuelta al cliente para edición. Espera la actualización para continuar el proceso.'
  },
  {
    status: 11,
    text: "El cliente ha solicitado una cancelación. Motivo: "
  },
  {
    status: 12,
    text: "La orden se encuentra en queja. Da seguimiento en la sección de quejas y comentarios."
  }
]

export const OrderLogs = {
  clientStatusLogs,
  adminStatusLogs,
  supplierStatusLogs,
  vendorStatusLogs,
  buyerStatusLogs
}